<script setup>
import { copyText } from '@/utilities/index.util.js';
import { useSlots, useTemplateRef } from 'vue';

const copyTextRef = useTemplateRef('copy-text-ref');

defineExpose({ copyTextRef });

defineProps({
  variant: {
    type: String
  }
});

const slots = useSlots();
const defaultSlot = slots.default?.();

const getSlotChildrenText = (children) => {
  return children
    .map((node) => {
      // this is a workaround for the v-currency component
      if (node.props?.amount) {
        return node.props.amount
      }
      if (!node.children || typeof node.children === 'string')
        return node.children || '';
      else if (Array.isArray(node.children))
        return getSlotChildrenText(node.children);
      else if (node.children.default)
        return getSlotChildrenText(node.children.default());
    })
    .join('');
}

const handleCopyText = (e) => {
  const text = getSlotChildrenText(defaultSlot);
  if (!text) return;
  e.stopPropagation();
  e.preventDefault();
  copyText(text);
};
</script>

<template>
  <div
    ref="copy-text-ref"
    class="v-copy-text"
    :class="`v-copy-text--${variant}`"
    @click="handleCopyText"
    :tabindex="variant ? 0 : -1"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.v-copy-text {
  cursor: copy;
  transition: color 0.2s ease;
  &:hover {
    color: var(--color-text-hover);
  }
  &--primary {
    display: inline;
    font-size: var(--type-caption);
    color: var(--color-text-subtle);
    &:active {
      color: var(--color-text-pressed);
    }
    &:focus-visible {
      outline: var(--border-stroke-strong) solid var(--color-secondary-border-default);
      outline-offset: 2px;
      border-radius: var(--radius-xsmall);
    }
  }
}
</style>
